import { useCallback, useEffect } from 'react'
import { useDeviceType } from '@/utils'

interface SlidePanelState {
  open: boolean
  onClose?: () => void
}

/**
 * Which edge the panel enters from, plus escape-to-close — a drawer that can
 * only be dismissed by hitting its own icon is a keyboard dead end.
 */
export function useSlidePanelController({ open, onClose }: SlidePanelState) {
  const { isDesktop } = useDeviceType()

  const onEscape = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose?.()
    },
    [onClose],
  )

  useEffect(() => {
    if (!open) return undefined

    window.addEventListener('keydown', onEscape)
    return () => window.removeEventListener('keydown', onEscape)
  }, [open, onEscape])

  return {
    // Up from the bottom as a sheet on mobile, in from the right as a card on desktop.
    direction: isDesktop ? ('left' as const) : ('up' as const),
    isModal: !isDesktop,
  }
}
